import { render, staticRenderFns } from "./LevelLink.vue?vue&type=template&id=6335af52&"
import script from "./LevelLink.vue?vue&type=script&lang=js&"
export * from "./LevelLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports